import { useEffect, useRef } from "react";

export default function useSeamlessLoopAudio(url, volume = 0.2, enabled = true) {
  const audioCtxRef = useRef(null);
  const sourceRef = useRef(null);
  const bufferRef = useRef(null);

  useEffect(() => {
    if (!enabled) return;

    audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();

    fetch(url)
      .then(res => res.arrayBuffer())
      .then(arrayBuffer => audioCtxRef.current.decodeAudioData(arrayBuffer))
      .then(audioBuffer => {
        bufferRef.current = audioBuffer;
        play();
      });

    function play() {
      if (!bufferRef.current) return;
      const source = audioCtxRef.current.createBufferSource();
      source.buffer = bufferRef.current;
      source.loop = true;

      const gain = audioCtxRef.current.createGain();
      gain.gain.value = volume;

      source.connect(gain).connect(audioCtxRef.current.destination);
      source.start(0);
      sourceRef.current = source;
    }

    return () => {
      sourceRef.current?.stop();
      audioCtxRef.current?.close();
    };
  }, [url, enabled, volume]);
}
